import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { 
	isNumericBoolean
} from '../../Utilities/adapter';
import ReactGA from 'react-ga';

const BASE_URL = process.env.REACT_APP_API_URL+'api';
let keystages = [];
const INITIAL_STATE = {
	resource: {
		title: '',
		keyword: '',
		type: 0,
		organisation_title: '',
		artsmark_partner: 0,
		support_send: '',
		keystages: [],
		artform: 0,
		venue_name: '',
		postcode: '',
		free: '',
		status: ''
	},
	keystage0: false,
	keystage1: false,
	keystage2: false,
	keystage3: false,
	keystage4: false,
	keystage5: false,
	artforms: [],
	events: [],
	types: [
		{
			id: 1,
			name: 'Activities and worksheets'
		},
		{
			id: 2,
			name: 'Audio resources'
		},
		{
			id: 3,
			name: 'Lesson plans'
		},
		{
			id: 4,
			name: 'Online platforms'
		},
		{
			id: 5,
			name: 'Teacher CPD'
		},
		{
			id: 6,
			name: 'Video resources'
		},
		{
			id: 7,
			name: 'Virtual tours'
		}
	],
	page: 1
};

class ResourceFilter extends Component {
	state = INITIAL_STATE;

	componentDidMount() {
		this.getArtformTypes();

		this.setState( prevState => ({
			...prevState,
			resource: {
				...prevState.resource,
				support_send: (this.props.support_send && this.props.support_send === 1) ? this.props.support_send : '',
				free: (this.props.free && this.props.free === 1) ? this.props.free : '',
			}
		}));
	}

	logEvent = (resource) => {
		ReactGA.event({
			category: 'Resource filter',
			action: 'Filter type: ' + resource.filterType,
			label: 'Filter value: ' + resource.filterLabel
		});
	}

	getArtformTypes = () => {
		axios.get(BASE_URL+'/artform-types')
		.then(response => {
			this.setState({
				artforms: response.data
			});
		});
	};

	onInputChange = (e) => {
		let fieldName = e.target.name;
		let fieldValue = e.target.value;

		if (e.target.type === 'checkbox') {
			let boolean = e.target.checked;
			let numericBoolean = isNumericBoolean(boolean);

			this.setState(
				prevState => ({ 
					resource: { ...prevState.resource, [fieldName] : numericBoolean }
				})
			);
		} else {
			this.setState(
				prevState => ({
					resource: { ...prevState.resource, [fieldName] : fieldValue }
				})
			);
		}
	}

	onPostcodeChange = (event) => {
		let fieldValue = event.target.value;

		this.setState(
			prevState => ({
				resource: { 
					...prevState.resource, 
					postcode : fieldValue,
					sort: 'distance'
				}
			})
		);
	};

	selectOption = (e) => {
		let fieldValue = e.target.value;
		let fieldName = e.target.name;

		this.setState(
			prevState => ({
				resource: { ...prevState.resource, [fieldName] : fieldValue }
			})
		);
	};

	selectKeystage = (e) => {
		let fieldValue = e.target.value;
		let keyName = e.target.id;

		if (e.target.checked) {
			keystages.push(parseInt(fieldValue));

			this.setState(
				prevState => ({
					resource: { ...prevState.resource, keystages: keystages },
					[keyName]: true
				})
			);				
		} else {
			keystages.pop();
			console.log(keystages);

			this.setState(
				prevState => ({
					resource: { ...prevState.resource, keystages: keystages },
					[keyName]: false
				})
			);	
		}
	};
	
	handleSubmit = (e) => {
		e.preventDefault();

		if (this.state.resource.keyword !== '') {
			this.logEvent({
				filterType: 'Search by keyword',
				filterLabel: 'Keyword: ' + this.state.resource.keyword 					
			});
		}

		if (this.state.resource.organisation_title !== '') {
			this.logEvent({
				filterType: 'Search by organisation',
				filterLabel: 'Organisation: ' + this.state.resource.organisation_title 					
			});
		}

		if (this.state.resource.keystages.length) {
			this.logEvent({
				filterType: 'Specific key stage',
				filterLabel: 'key stage: ' + this.state.resource.keystages
			});
		}

		if (this.state.resource.free !== '') {
			this.logEvent({
				filterType: 'Free',
				filterLabel: this.state.resource.free
			});
		}

		if (this.state.resource.artsmark_partner !== 0) {
			this.logEvent({
				filterType: 'Artsmark partner',
				filterLabel: this.state.resource.artsmark_partner
			});
		}

		if (this.state.resource.support_send !== 0) {
			this.logEvent({
				filterType: 'Accessible for SEND students',
				filterLabel: this.state.resource.support_send
			});
		}

		if (this.state.resource.artform !== 0) {
			const artName = this.state.artforms.filter(art => {
				return art.id === parseInt(this.state.resource.artform);
			});

			this.logEvent({
				filterType: 'Artform',
				filterLabel: artName[0].name
			});
		}

		if (this.state.resource.type !== 0) {
			const type = this.state.types.filter(type => {
				return type.id === parseInt(this.state.resource.type);
			});

			this.logEvent({
				filterType: 'Type',
				filterLabel: type[0].name
			});
		}

		this.props.onFilteredResults(this.state);
	};

	onClearFilter = (e) => {
		e.preventDefault();

		this.setState(INITIAL_STATE, () => {
			keystages = [];
			this.props.onClearFilter();
		});
	};

	renderArtformSelection() {
		return (
			<select 
				onChange={this.onInputChange} 
				value={this.state.resource.artform} 
				name="artform" 
				id="artform" 
				className="form-control tab-filter-select"
			>
				<option value={0}>CHOOSE</option>
				{this.state.artforms.map(art =>
					<option key={art.id} value={art.id}>{art.name}</option>
				)}
			</select>
		);
	}

	renderForm () {

		return (
			<form className="tab-filter-form">
				<div className="row">
					<div className="col-12 col-md-6 order-md-1">
						<div className="row mb-2 flex-column flex-lg-row">
							<div className="col-12 col-md-3">
								<label htmlFor="type" className="tab-filter-label">Type</label>
							</div>

							<div className="col">
								<select 
									onChange={this.onInputChange} 
									value={this.state.resource.type} 
									name="type" id="type" 
									className="form-control tab-filter-select"
								>
									<option value={0}>CHOOSE</option>
									<option value={1}>Activities and worksheets</option>
									<option value={2}>Audio resources</option>
									<option value={3}>Lesson plans</option>
									<option value={4}>Online platforms</option>
									<option value={5}>Teacher CPD</option>
									<option value={6}>Video resources</option>
									<option value={7}>Virtual tours</option>
								</select>
							</div>
						</div>

						<div className="row mb-2 flex-column flex-lg-row">
							<div className="col-12 col-md-3">
								<label htmlFor="artform" className="tab-filter-label">Artform</label>
							</div>

							<div className="col">
								{ this.renderArtformSelection() }
							</div>
						</div>

						<div className="row mb-2 flex-column flex-lg-row">
							<div className="col-12 col-md-3 d-flex align-items-center">
			    				<label htmlFor="keystage" className="tab-filter-label specific-keystage">Specific key stage</label>
			    			</div>

			    			<div className="col">
				    			<div id="keystage" className="d-flex justify-content-between text-white">
									<div>
					    				<label htmlFor="keystage0" className="mx-1 mb-0">EY</label>
					    				<input 
					    					onChange={this.selectKeystage} 
					    					checked={this.state.keystage0} 
					    					id="keystage0" 
					    					type="checkbox" 
					    					name="keystages" 
					    					value={0} 
					    				/>
					    			</div>
					    			<div>
					    				<label htmlFor="keystage1" className="mx-1 mb-0">1</label>
					    				<input 
					    					onChange={this.selectKeystage} 
					    					checked={this.state.keystage1} 
					    					id="keystage1" 
					    					type="checkbox" 
					    					name="keystages" 
					    					value={1} 
					    				/>
					    			</div>
					    			<div>
					    				<label htmlFor="keystage2" className="mx-1 mb-0">2</label>
					    				<input 
					    					onChange={this.selectKeystage} 
					    					checked={this.state.keystage2} 
					    					id="keystage2" 
					    					type="checkbox" 
					    					name="keystages" 
					    					value={2} 
					    				/>
					    			</div>
					    			<div>
					    				<label htmlFor="keystage3" className="mx-1 mb-0">3</label>
					    				<input 
					    					onChange={this.selectKeystage} 
					    					checked={this.state.keystage3} 
					    					id="keystage3" 
					    					type="checkbox" 
					    					name="keystages" 
					    					value={3} 
					    				/>
					    			</div>
					    			<div>
					    				<label htmlFor="keystage4" className="mx-1 mb-0">4</label>
					    				<input 
					    					onChange={this.selectKeystage} 
					    					checked={this.state.keystage4} 
					    					id="keystage4" 
					    					type="checkbox" 
					    					name="keystages" 
					    					value={4} 
					    				/>
					    			</div>
					    			<div>
					    				<label htmlFor="keystage5" className="mx-1 mb-0">5</label>
					    				<input 
					    					onChange={this.selectKeystage} 
					    					checked={this.state.keystage5} 
					    					id="keystage5" 
					    					type="checkbox" 
					    					name="keystages" 
					    					value={5} 
					    				/>
					    			</div>
				    			</div>
				    		</div>
			    		</div>

			    		<div className="d-flex row">
				    		<div className="col-12 col-md-8 d-flex mb-2 mb-md-0 align-items-center">
				    			<label className="mr-auto mr-lg-2 mb-0 tab-filter-label" htmlFor="eventSuitable">Accessible for SEND students</label>
								<input 
									onChange={this.onInputChange} 
									value={this.state.resource.support_send} 
									checked={this.state.resource.support_send} 
									id="eventSuitable" 
									type="checkbox" 
									name="support_send" 
								/>
				    		</div>

				    		<div className="col-12 col-md d-flex mb-2 mb-md-0 justify-content-end align-items-center">
				    			<label className="mr-auto mr-lg-2 mb-0 tab-filter-label" htmlFor="eventFree">Free</label>
								<input 
									onChange={this.onInputChange} 
									value={this.state.resource.free} 
									checked={this.state.resource.free} 
									id="eventFree" 
									type="checkbox" 
									name="free" 
								/>
				    		</div>
				    	</div>
		    		</div>

					<div className="col-12 col-md-6 order-md-2 mb-2 mb-md-0">
						<div className="row mb-2 flex-column flex-lg-row">
							<div className="col-12 col-md-3">
								<label htmlFor="eventByName" className="tab-filter-label">Keyword</label>
							</div>

							<div className="col">
								<input 
									onChange={this.onInputChange} 
									value={this.state.resource.keyword} 
									id="eventByName" 
									type="text" 
									name="keyword" 
									placeholder="SEARCH BY KEYWORD" 
									className="form-control" 
								/>
							</div>
						</div>

						<div className="row mb-2 flex-column flex-lg-row">
							<div className="col-12 col-md-3">
								<label htmlFor="eventByOrg" className="tab-filter-label">Organisation</label>
							</div>

							<div className="col">
								<input 
									onChange={this.onInputChange} 
									value={this.state.resource.organisation_title} 
									id="eventByOrg" 
									type="text" 
									name="organisation_title" 
									placeholder="SEARCH BY ORGANISATION" 
									className="form-control" 
								/>
							</div>
						</div>

			    		<div className="row">
							<div className="col offset-lg-3">
								<button 
									onClick={this.handleSubmit} 
									className="btn btn-dark btn-lg font-weight-bold text-white">SHOW RESULTS</button>
								<button 
									onClick={this.onClearFilter} 
									className="btn text-light font-weight-bold text-underline">CLEAR FILTERS</button>
							</div>
						</div>
					</div>
				</div>
			</form>
		);
	}

	render () {
		return (
			<Fragment>
				<section className="bg-primary">
					<div className="tab-filters container">
						{ this.renderForm() }
					</div>
				</section>
			</Fragment>
		)
	}
}

export default ResourceFilter;